<template>
  <b-modal class="chatter-modal"
            ref="chatter-modal"
           :id="tableType"
           :size="size"
           @ok="handleOk(tableType)">
    <template #modal-header>
      <h5>{{ tableTitle }}</h5>
      <!-- 닫기 버튼 마크업 추가 -->
      <button type="button"
              class="btn-popup-close"
              @click="hideChatterModal"></button>
    </template>
    <!-- add watcher 팝업에서도 input 노출 필요 -->
    <template v-if="tableType!='watchersTable'">
      <b-form @submit.prevent>
        <b-row>
          <!-- Keyword -->
          <b-col cols="11" class="pr-0">
            <b-input-group size="sm">
              <b-form-input placeholder="Search..."
                            @keyup.enter="reload"
                            v-model="keyword"
                            b-input
                            onsubmit="return false;"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col cols="1" class="p-0">
            <button @click="reload" class="modal-search-button"><b-icon icon="search"></b-icon></button>
          </b-col>
          <!-- Keyword -->
        </b-row>
      </b-form>
    </template>
    <modal-table :tableType="table"
                 :ref="tableType"
                 :selectType="selectType"
                 :selectedValues="selectedValues"
                 :keyword="keyword"
                 :notForShowValues="notForShowValues"
                 :projectId="projectId"
                 :list="list"

                 @set-result="saveSelectedItems"></modal-table>
    <template #modal-footer="{ ok, cancel }">
      <!-- <b-button variant="primary" :disabled="selectedItemSize <= 0" -->
      <b-button variant="primary" :disabled="isDisabledOkButton" 
                @click="ok()">OK
      </b-button>
      <b-button variant="secondary"
                @click="cancel()">Cancel
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import modalTable from '@/components/chatter/chat/ChatterModalTable.vue';

export default {
  name: 'ChatterModal',
  props: {
    tableType: String,
    selectType: String,
    selectedValues: Array,  // 모달 오픈 이전에 선택되어있던 값들
    projectId: String,
    notForShowValues: Array,
    list: null,
  },
  components: { modalTable },
  data() {
    return {
      keyword: '',
      selectedItems: [],
      isDisabledOkButton: true
    }
  },
  
  methods: {
    reload() {
      this.$refs[this.tableType].retreiveData();
    },
    openModal(ref) {
      this.$bvModal.show(ref);
    },
    closeModal() {
      this.$bvModal.close(this.tableType);
      this.isDisabledOkButton = true;
    },
    handleOk(table) {
      // list: 기존 값, selectedItems: 새롭게 선택된 값
      this.$emit("set-result", this.selectedItems, this.list);
      this.isDisabledOkButton = true;
      // this.$refs[table].returnSelectedList();
    },
    saveSelectedItems(selectedItems) {
      this.selectedItems = selectedItems;

      // 기존 값과 선택한 후의 값을 비교하여 ok버튼 활성화 여부 결정
      console.log(this.isEqualArrays(this.selectedValues, this.selectedItems));
      if(this.isEqualArrays(this.selectedValues, this.selectedItems)) {
        this.isDisabledOkButton = true;
      } else {
        this.isDisabledOkButton = false;
      }
      // console.log(this.isDisabledOkButton);
    },
    isEqualArrays(array1, array2) {
      // console.log(array1);
      // console.log(array2);
      if(array1.length !== array2.length) {
        return false;
      }

      switch (this.table) {
        case 'user':
          // 문자열 배열 비교
          const sortedUserEmailArray1 = array1.slice().sort((a, b) => a.localeCompare(b));
          const sortedUserEmailArray2 = array2.slice().sort((a, b) => a.localeCompare(b)); 
          for (let i = 0; i < sortedUserEmailArray1.length; i++) {
              if (sortedUserEmailArray1[i].chatId !== sortedUserEmailArray2[i].chatId) {
                  return false;
              }
          }
          return true;
          break;
        case 'chatter':
          // 객체 배열 비교
          const sortedChatArray1 = array1.slice().sort((a, b) => a.chatId.localeCompare(b.chatId));
          const sortedChatArray2 = array2.slice().sort((a, b) => a.chatId.localeCompare(b.chatId));

          for (let i = 0; i < sortedChatArray1.length; i++) {
              if (sortedChatArray1[i].chatId !== sortedChatArray2[i].chatId) {
                return false;
              }
          }
          return true;
          break;
      }
    },
    // setResult(selectedResult, list) {
    // },
    hideChatterModal(){
      this.$refs['chatter-modal'].hide();
    }
  },
  computed: {
    table() {
      switch (this.tableType) {
        case 'watchersTable':
          return "user";
        case 'subordinateToTable':
          return "chatter"
        case 'relatedToTable':
          return "chatter"
        default:
          return '';
      }
    },
    size() {
      switch (this.tableType) {
        case 'watchersTable':
          return "md";
        case 'subordinateToTable':
          return "lg"
        case 'relatedToTable':
          return "lg"
        default:
          return '';
      }
    },
    //modal의 title
    tableTitle(){
      switch (this.tableType) {
        case 'watchersTable':
          return "Watcher";
        case 'subordinateToTable':
          return "Chatter"
        case 'relatedToTable':
          return "Chatter"
        default:
          return '';
      }
    },
  },
}
</script>

<style scoped>
.modal-dialog .modal-content footer.modal-footer {
    display: flex !important;
    justify-content: flex-start !important;
    align-items: center !important;
}

.modal-body {
    padding-top: 0px !important;
    padding-bottom: 0px !important;

}

#chatterModal {
    height: 453px;
    margin: 0px;
}

.btn-popup-close {
    display: block;
    width: 30px;
    height: 30px;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M22.5 22.5L7.5 7.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5 7.5L7.5 22.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat transparent;
    border: none;
}

.modal-body .input-group {
    margin-bottom: 2rem;
    padding-right: 16px;
}

.modal-body .input-group > .form-control {
    padding: 0.533rem 0.8rem 0.533rem 1.066rem;
    height: 2.666rem !important;
    border-radius: 10px;
    border: 1px solid #E7E7EE;
    background-color: #F6F6FA;
    font-family: 'NanumGothic';
    color: #2E2E38;
    font-size: 16px;
    font-weight: 400;
    line-height: 150% !important;
}
.modal-search-button {
  border: none;
  color: #FFE305;
  font-weight: bold;
  padding: 0 1rem;
  background-color: #2E2E38;
  border-radius: 10px;
}
</style>